
/* injects from baggage-loader */

'use strict';

export default class AccountSettingsPaymentsController {

	constructor($log, $scope, $timeout, $document, $uibModal, User, Parse, Alerts) {
		'ngInject';

		this.heading = 'My Payment Methods';

		this.$log = $log;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$document = $document;
		this.$uibModal = $uibModal;
		this.User = User;
		this.Parse = Parse;
		this.Alerts = Alerts;

		this.accounts = [];
		this.cards = [];

	}

	$onInit() {
		// this.$log.log(this.User.getCurrent());
		// this.$log.log(this.stripeAccount);

		// Assign linked banks accounts
		if (this.stripeAccount && this.stripeAccount.sources && this.stripeAccount.sources.data) {
			for (let source of this.stripeAccount.sources.data) {
				// this.$log.log(source)
				if (source.object === 'card') {
					this.cards.push(source);
				} else if (source.object === 'bank_account') {
					if (source.status === 'new') {
						source.open_details = true
					}
					this.$log.log(source)
					this.accounts.push(source);
				} else {
					/* do nothing */
				}
			}
		}

		// Listen for events when a new bank account is added
		this.$scope.$on('accountSettings.newBankAccount', (event, account) => {

			// Close the bank account form
			this.isAddingBankAccount = false;

			// Open the account details
			account.open_details = true;

			// Push the new account to accounts
			this.accounts.push(account);

		});


		// Listen for events to close the bank account form
		this.$scope.$on('accountSettings.closeAddBankAccountForm', event => {

			// Close the bank account form
			this.isAddingBankAccount = false;

			// Scroll to the top of the page
			// this.$document.scrollTopAnimated(0);

		});

		// Listen for events when a card is added
		this.$scope.$on('accountSettings.newCard', (event, card) => {

			// Close the card form
			this.isAddingCard = false;

			// Push the new card to cards
			this.cards.push(card);

			// Scroll to the top of the page
			this.$document.scrollTopAnimated(0);

		});

		// Listen for events to close the card form
		this.$scope.$on('accountSettings.closeAddCardForm', event => {

			// Close the card form
			this.isAddingCard = false;

			// Scroll to the top of the page
			// this.$document.scrollTopAnimated(0);

		});
	}

	addBankAccount() {

		// Open the Add Bank Account component
		this.isAddingBankAccount = true;

		// Scroll down to the form
		this.$timeout(() => {
			let element = angular.element(document.getElementById('bank_accounts'));
			this.$document.scrollToElementAnimated(element, 80);
		}, 100);

	}

	addCard() {

		// Open the Add Card component
		this.isAddingCard = true;

		// Scroll down to the form
		this.$timeout(() => {
			let element = angular.element(document.getElementById('cards'));
			this.$document.scrollToElementAnimated(element, 80);
		}, 100);
	}

	verifyBankAccount(account, amount1, amount2) {

		// Check that two amounts were entered
		// if (!amount1 || !amount2) {

		// }

		account.isVerifying = true;
		account.verification_error = '';

		this.Parse.Cloud.run('verifyBankAccount', {
			amounts: [amount1.split('.')[1] || 0, amount2.split('.')[1]  || 0],
			account_id: account.id
		}).then(res => {
			this.$log.log(res)
			account.isVerifying = false;
			this.$log.log('Account verified:', account.id);
			account.status = 'verified';
			account.open_details = false;

			// Display local alert
			this.Alerts.setLocal({
				msg: `Bank account verified successfully`,
				type: 'success'
			});

			// Scroll to the top of the page
			this.$document.scrollTopAnimated(0);

			this.$timeout();
		})
		.catch(err => {
			this.$log.error(err);
			err = err.toString().replace('ParseError: 141 Error:', '').trim();
			account.isVerifying = false;
			account.verification_error = err;
			this.$timeout();
		})
	}

	toggleSourceDetails(source) {
		source.open_details = source.open_details ? false : true;
	}

	/**
	 * Unlink a payment source from the users Stripe account
	 * @param {Object} source 
	 */
	removePaymentSource(source) {
		// this.$log.log(source);

		// Display prompt modal
		let modalInstance = this.$uibModal.open({
			animation: true,
			component: 'modalComponent',
			resolve: {
				context: function () {
					return {
						title: `Remove ${source.object === 'card' ? 'card' : 'bank account'}?`,
						body: `Are you sure you want to remove the ${source.object === 'card' ? 'card' : 'bank account'} ending in ${source.last4}?`,
						confirmBtnText: 'Yes, Remove',
						cancelBtnText: 'No, Cancel'
					};
				}
			}
		});


		modalInstance.result.then(async () => {

			source.removing = true;

			try {

				// Remove the bank account from the users stripe account
				let result = await this.Parse.Cloud.run('unlinkPaymentSource', {
					source: source.id
				});

				this.$log.log(result);
				if (result.deleted) {

					if (source.object === 'bank_account') {

						// Remove the account from accounts
						let idx = this.accounts.findIndex(acc => acc.id === source.id);
						this.accounts.splice(idx, 1);

					} else {

						// Remove the card from cards
						let idx = this.cards.findIndex(card => card.id === source.id);
						this.cards.splice(idx, 1);

					}

					// Display local alert
					this.Alerts.setLocal({
						msg: `${source.object === 'card' ? 'Card' : 'Bank Account'} removed successfully`,
						type: 'success'
					});

					// this.$timeout();
				}

			} catch (err) {

				this.$log.error(err);

				// Display local alert
				this.Alerts.setLocal({
					msg: `Failed to remove ${source.object === 'card' ? 'card' : 'bank account'}. Please contact support if the problem persists.`,
					type: 'danger'
				});

			}

		}, () => { /* empty */ });

	}
}



// WEBPACK FOOTER //
// ./src/app/pages/account/settings/payments/account.settings.payments.controller.js